export default {
  SLUG: 'ws-contact-info',
  TRIGGER_ID: 'contact-info',
};
